import { 
    COLLECTION_STATISTICS,
    COLLECTION_STATISTICS_SUCCESS 
} from './constants';

/**
 *
 * @param hatchId
 * @param text
 * @returns {{hatchId: *, text: *, type: string}}
 */
const collectionStatisticsShare = (hatchId, text) => ({
    type: COLLECTION_STATISTICS,
    hatchId,
    text
});

/**
 *
 * @param sharing
 * @returns {{type: string, sharing: *}}
 */
const collectionStatisticsShareSuccess = (sharing) => ({
    type: COLLECTION_STATISTICS_SUCCESS,
    sharing
});

export {
    collectionStatisticsShare,
    collectionStatisticsShareSuccess
};